import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campKcrReorder: FaireAdCampaignEntity = {
  token: "camp_kcr_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_keystone_crystals",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2222,
  startedRunningAt: "2026-01-15",
  segmentMetrics: {
    numReorderConversions: 201,
    salesDollars: 65830,
    totalAdsSpendDollars: 5941,
    returnOnAdSpend: 11.08,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
